import script from "./AreaSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaSelector.vue?vue&type=script&setup=true&lang=js"

import "./AreaSelector.vue?vue&type=style&index=0&id=5c37e18a&scoped=true&lang=css"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c37e18a"]])

export default __exports__